export default "__VITE_ASSET__CLbsNoqg__"